import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import FlipMove from 'react-flip-move';
import { Link } from 'react-router-dom';
import classes from './LogsFilter.module.css';
import { truncateText } from 'shared/utility';

const logsFilter = (props) => {
  const sortedLogs = props.allLogs
    ? props.allLogs.sort((a, b) => {
        if (a.Visibility === 'Private' && props.selectedLogIds.includes(a.Id)) {
          return -1;
        }
        if (b.Visibility === 'Private' && props.selectedLogIds.includes(b.Id)) {
          return 1;
        }
        if (props.selectedLogIds.includes(a.Id) && !props.selectedLogIds.includes(b.Id)) {
          return -1;
        }
        if (!props.selectedLogIds.includes(a.Id) && props.selectedLogIds.includes(b.Id)) {
          return 1;
        }
        if (a.Visibility === 'Private') {
          return -1;
        }
        if (b.Visibility === 'Private') {
          return 1;
        }
        if (a.Name < b.Name) {
          return -1;
        }
        if (a.Name > b.Name) {
          return 1;
        }
        return 0;
      })
    : [];

  let logsList = [];

  if (sortedLogs.length > 0) {
    logsList = (
      <FlipMove duration={500}>
        {sortedLogs.map((log) => (
          <div
            key={log.Id}
            className={props.selectedLogIds.includes(log.Id) ? [classes.LogListItem, classes.Selected].join(' ') : classes.LogListItem}
            onClick={() => props.handleLogSelect(log.Id)}
          >
            <span>{truncateText(log.Name, 29)}</span>
            {props.selectedLogIds.includes(log.Id) ? <FontAwesomeIcon icon="check" className={classes.CheckMark} /> : null}
          </div>
        ))}
      </FlipMove>
    );
  }

  return (
    <div className={classes.LogsFilterContainer}>
      <div className={classes.LogControls}>
        <span onClick={props.selectAll}>Select All</span>
        <span onClick={props.clearAll}>Clear</span>
      </div>
      <div className={classes.ScrollContainer}>
        <div className={classes.LogsList}>
          <div className={classes.SelectedLogs}>{logsList}</div>
        </div>
        <div className={classes.BottomControls}>
          <Link to="/manage/logs">Manage Logs</Link>
        </div>
      </div>
    </div>
  );
};

export default logsFilter;
